module.exports = __webpack_public_path__ + "static/media/campaign-icon.8b1a1132.png";